export default [
  {
    title: '<i>01</i>안정적인 글로벌 <br class="hidden-sm-down"/>전용회선',
    copy: '북반구 전체를 커버하는 <br class="hidden-md-down hidden-xxl-up"/>회선 연동',
    exp:
      '글로벌 리전 서비스는 전 세계 주요 거점을 연결하는 글로벌 전용회선을 통해 일반 인터넷 회선과 달리 다른 통신의 영향을 최소화해 안정적인 서비스를 제공합니다.<br> 글로벌 사업자들이 모이는 네트워크 요충지에 상면을 확보하고 해당 상면들을 3~4중화 된 회선으로 연결해, 북반구 전체를 커버하도록 회선을 연동했습니다.<br> 단, 거점 간 통신 속도는 거리에 따라 서로 다르게 나타날 수 있습니다.',
  },
  {
    title: '<i>02</i>신뢰할 수 있는 보안',
    copy: 'IDS 기반으로 <br class="hidden-md-down hidden-xxl-up"/>24시간 X 365일 보호',
    exp:
      '모든 글로벌 리전은 IDS를 기반으로 한 Basic Security 보안 서비스로 고객의 데이터를 24시간, 365일 보호하고 있으며, Security Monitoring 서비스를 중심으로 한 높은 수준의 보안 서비스를 제공합니다.',
    subExp01: 'IDS : Intrusion Detection System 침입탐지시스템',
    subExp02: 'Security Monitoring 서비스 : 한국, 싱가포르, 일본, 미국(서부), 독일 리전만 가능함. 추후 모든 리전으로 확대 준비 중',
  },
  {
    title: '<i>03</i>탁월한 시스템  <br class="hidden-sm-down"/>가용성',
    copy: '이중화를 통한 가용성 확보',
    exp:
      '스위치, 보안 장비, 서버의 HA(High Availability) 구성으로 시스템 가용성을 보장하고 있으며, 모든 글로벌 리전 구성을 이중화하여 서비스의 안정성과 가용성을 높였습니다.<br> 특히, 글로벌 거점들을 전용 ISP 회선으로 연결해 유사시에도 이상 없는 서비스를 제공합니다.',
  },
  {
    title: '<i>04</i>웹 기반 콘솔 환경의 <br/>편의성',
    copy: '기존과 동일한 웹 기반 콘솔 환경',
    exp: '글로벌 리전 서비스는 웹 기반의 콘솔 환경을 기존 콘솔과 동일한 모습과 기능으로 유지합니다.<br> 사용자는 원하는 리전을 선택해 편리하게 서비스를 이용할 수 있습니다.',
  },
  {
    title: '<i>05</i>효율적인 <br class="hidden-sm-down hidden-lg-up"/>비용 관리',
    copy: '국내와 동일한 요금 정책',
    exp:
      '국내보다 상대적으로 높은 비용이 발생하는 글로벌 리전에도 국내와 동일한 요금 정책으로 서비스 사용자에게 비용 절감 효과를 제공합니다.<br> 특히, 오랜 기간 대규모 투자가 투입된 글로벌 전용회선을 저렴하게 제공하여, 전용회선을 통한 서버 이미지 및 스냅샷의 리전 간 복제를 무료로 사용할 수 있도록 했습니다.',
  },
  {
    title: '<i>06</i>글로벌 리전 리빌딩',
    copy: '국내와 동일한 서비스 이용',
    exp:
      '국내에서 이용하는 서비스를 글로벌 리전에서도 그대로 이용할 수 있도록 지속적인 업데이트를 하고 있습니다.<br> 이를 위해 각 리전 별로 인프라와 네트워크를 새롭게 정비하고 있으며, 2020년 기준, 싱가포르, 일본, 미국(서부), 독일 리전에서 국내 리전 환경과 동일한 서비스를 이용할 수 있습니다.',
  },
];
